import React, { useEffect, useRef } from "react";
import { Sparkles, Zap, Trophy } from "lucide-react";
import "./BrandStory.css";

const BrandStory = () => {
  const storyRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (storyRef.current) {
      observer.observe(storyRef.current);
    }

    return () => {
      if (storyRef.current) {
        observer.unobserve(storyRef.current);
      }
    };
  }, []);

  return (
    <section id="story" className="brand-story" ref={storyRef} aria-labelledby="story-title">
      <div className="story-container">
        <div className="story-header">
          <span className="story-label">WHO WE ARE</span>
          <h2 className="story-title" id="story-title">THE ODD ADVANTAGE</h2>
        </div>
        <div className="story-content">
          <p className="story-text">
            In a world of cookie-cutter campaigns and predictable production,
            we are the anomaly. <strong>Oddtive</strong> doesn't follow trends—we
            engineer cultural moments.
          </p>
          <p className="story-text">
            We craft visual narratives that don't just capture attention—they
            command it. From high-octane social campaigns to cinematic brand
            films, every frame is architected for maximum emotional resonance
            and commercial impact.
          </p>
          <p className="story-text">
            Our clients don't hire us for safe. They hire us to <strong>break the
            mold</strong>, disrupt their industries, and own their narrative with
            ruthless creativity and surgical precision.
          </p>
        </div>
        <div className="story-values">
          <div className="value-card">
            <div className="value-icon">
              <Sparkles size={32} strokeWidth={1.5} />
            </div>
            <h3 className="value-title">Unconventional</h3>
            <p className="value-desc">We reject the ordinary and embrace the unexpected.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <Zap size={32} strokeWidth={1.5} />
            </div>
            <h3 className="value-title">High-Impact</h3>
            <p className="value-desc">Every project is designed to create measurable momentum.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">
              <Trophy size={32} strokeWidth={1.5} />
            </div>
            <h3 className="value-title">Premium Craft</h3>
            <p className="value-desc">We deliver world-class quality without compromise.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandStory;